import { memoize } from 'lodash/fp'
import L from 'leaflet'
import React from 'react'
import { Card, H5, Col } from '../../Elements'


export const colors = [
    '#8b0e0e',
    '#399a0f',
    '#0f759a',
    '#6710a5',
    '#960f98',
    '#9d5c10',
    '#ccb514',
    '#0f9b8a',
    '#90b117',
    '#0f5196',
    '#950f5a',
    '#cd0000',
    '#13be13',
    '#1572d2',
    '#be93d4',
    '#33dfff',
    '#e6c510',
    '#0e89ad',
    '#1f8f4e',
    '#ea9c0b',
    '#ff1493',
    '#313131',
    '#f1f1f1'
]

const baseProps = {
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
}

const getIcons = () => {
    let icons = {
        'default': new L.Icon({
            ...baseProps,
            iconUrl: require(`./icons/marker-icon-2x-black.png`)
        })
    }
    colors.forEach(c => {
        icons[c] = new L.Icon({
            ...baseProps,
            iconUrl: require(`./icons/marker-icon-2x-${c.slice(1)}.png`)
        })
    })
    return icons
}

export const colorIcons = memoize(getIcons)()

export const Legend = ({markerColors}) => {
    return (
        <>
            <Card style={{ margin: 0, width: 500 }}>
                <H5>Legend</H5>
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                    {
                        markerColors.map((c, idx) => {
                            return (
                                <>
                                    <Col xs={4}>
                                        <p style={{ fontSize: '9pt', fontWeight: 'bold', marginRight: 10 }} key={`legend-${idx}`}>
                                            <img
                                                src={require(`./icons/marker-icon-2x-${c.color.replace('#', '').toLowerCase()}.png`)}
                                                alt={c.name}
                                                width='20px'
                                                style={{ verticalAlign: 'middle' }}
                                            />
                                            <span > - {c.name}</span></p>
                                    </Col>
                                </>
                            )
                        })
                    }

                </div>
            </Card>
        </>
    )
}
